'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var marked = require('marked');
var hl = require('highlight.js/lib/highlight');
var defalutLanguages = ['javascript', 'bash', 'xml', 'css', 'markdown', 'less'];

exports.default = function () {
  var languages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defalutLanguages;

  languages.forEach(function (langName) {
    var langModule = require('highlight.js/lib/languages/' + langName);
    hl.registerLanguage(langName, langModule);
  });

  var renderer = new marked.Renderer();
  var codeRenderer = function codeRenderer(code, lang) {
    lang = lang === 'js' ? 'javascript' : lang;
    if (lang === 'html') {
      lang = 'xml';
    }

    var hlCode = lang ? hl.highlight(lang, code).value : hl.highlightAuto(code).value;
    return '<div class="doc-highlight"><pre><code class="' + (lang || '') + '">' + hlCode + '</code></pre></div>';
  };

  renderer.code = codeRenderer;

  return renderer;
};